/*
 * @Description: 企业展示-资讯详情
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-18 21:37:08
 * @LastEditTime: 2019-07-24 14:05:53
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 查看详情
export const detailsSee = (params, id) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/cms/news/getInfo`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getNews',
        id: id
      }, params))
    }
  })
}
